import { Badge } from "@devhop/ui";

export function LiveStatusBadge({ label }: { label: string }) {
  return <Badge variant="secondary">{label}</Badge>;
}
